/** Compact mark for an organization or person. Uses the first letters, or the first two characters. */
export function markFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "•";
  const chars =
    parts.length === 1
      ? Array.from(parts[0] ?? "").slice(0, 2)
      : [Array.from(parts[0] ?? "")[0], Array.from(parts[1] ?? "")[0]].filter(
          (char): char is string => Boolean(char),
        );
  return chars.join("").toLocaleUpperCase();
}
